module.exports = __webpack_public_path__ + "static/media/undraw_business_shop_qw5t.424452f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Media/images/undraw_business_shop_qw5t.svg
// module id = 198
// module chunks = 0